module.exports = __webpack_public_path__ + "img/noEvaluation.16f8e6ef.png";